import React, { type FC } from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import {
	Badges,
	BottomNavigationLink,
	Brand,
	DownloadButton,
	Paragraph,
	Title,
	TopGrid,
	Wrapper,
} from '@presentation/components/Footer/styles';
import downloadGoogle from '@presentation/assets/download-google.png';
import downloadApple from '@presentation/assets/download-apple.png';
import { Trans, useTranslation } from 'react-i18next';
import { LINK_APPLE_STORE, LINK_PLAY_STORE } from '@main/config/links';
import { useNavigate } from 'react-router-dom';

export const Footer: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<Wrapper>
			<Container maxWidth='xxl'>
				<TopGrid container spacing={4}>
					<Grid item xs={12} md={6}>
						<Brand>Jigsaw Puzzle Universe</Brand>
						<Paragraph variant='body1'>
							<Trans i18nKey='general.footer.tagline' />
						</Paragraph>
						<Badges>
							<Link href={LINK_PLAY_STORE} target='_blank'>
								<DownloadButton src={downloadGoogle} alt={t('general.downloadPlayStore')} />
							</Link>
							<Link href={LINK_APPLE_STORE} target='_blank'>
								<DownloadButton src={downloadApple} alt={t('general.downloadAppStore')} />
							</Link>
						</Badges>
					</Grid>
					<Grid item xs={6} md={3}>
						<Title variant='h4'>
							<Trans i18nKey='general.footer.navigation' />
						</Title>
						<BottomNavigationLink href='/' onClick={() => navigate('/')}>
							<Trans i18nKey='general.menu.homepage' />
						</BottomNavigationLink>
						<BottomNavigationLink href='/categories' onClick={() => navigate('/categories')}>
							<Trans i18nKey='general.menu.categories' />
						</BottomNavigationLink>
						<BottomNavigationLink href='/creators' onClick={() => navigate('/creators')}>
							<Trans i18nKey='general.menu.creators' />
						</BottomNavigationLink>
						<BottomNavigationLink href='/benefits' onClick={() => navigate('/benefits')}>
							<Trans i18nKey='general.menu.benefits' />
						</BottomNavigationLink>
						<BottomNavigationLink href='/about' onClick={() => navigate('/about')}>
							<Trans i18nKey='general.menu.about' />
						</BottomNavigationLink>
					</Grid>
					<Grid item xs={6} md={3}>
						<Title variant='h4'>
							<Trans i18nKey='general.footer.legal' />
						</Title>
						<BottomNavigationLink href='https://www.gotiva.global/terms-and-conditions-for-creators'>
							<Trans i18nKey='general.menu.termsAndConditions' />
						</BottomNavigationLink>
						<BottomNavigationLink href='https://www.gotiva.global/privacy-policy'>
							<Trans i18nKey='general.menu.privacyPolicy' />
						</BottomNavigationLink>
						<BottomNavigationLink href='https://www.gotiva.global'>
							<Trans i18nKey='general.menu.support' />
						</BottomNavigationLink>
					</Grid>
				</TopGrid>
			</Container>
		</Wrapper>
	);
};
